<mat-dialog-content>
    <h4>Schwellenwerte einstellen</h4>

    <div>
        <div>
            Erstellung von Schwellenwerten <button mat-icon-button
                (click)="addErrorTresholdparameters()">
                <img src="assets/icons/add_material.svg" height="24"/>
            </button> <!-- ggf. dezenter -->
            <div *ngFor="let param of errorThresholdParameters">
                <mat-form-field>
                    <mat-label>Error Level</mat-label>
                    <mat-select [(ngModel)]="param.errorLevel"
                        [ngClass]="isDuplicateErrorLevelAndTypeOfNewParams(param) ? 'isDuplicate' : ''">
                        <mat-option [value]="0">Warnung</mat-option>
                        <mat-option [value]="1">Fehler</mat-option>
                        <mat-option [value]="2">Kritischer Fehler</mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field>
                    <mat-label>Error Type</mat-label>
                    <mat-select [(ngModel)]="param.errorType" style="color: black"
                        [ngClass]="isDuplicateErrorLevelAndTypeOfNewParams(param) ? 'isDuplicate' : ''">

                        <mat-option [value]=1>Kanalfehler</mat-option>
                        <mat-option *ngIf="kanal?.localbusAddress === 1 || kanal?.localbusAddress === 2"
                            [value]=2>Pixelfehler</mat-option>
                        <mat-option *ngIf="kanal?.localbusAddress === 10" [value]=3>Spannungsfehler</mat-option>
                        <mat-option *ngIf="kanal?.localbusAddress === 12" [value]=4>Brennstoffwarnung</mat-option>
                        <mat-option *ngIf="kanal?.localbusAddress === 12" [value]=5>Systemstatus
                            Brennstoffzelle</mat-option>
                        <mat-option
                            *ngIf="kanal?.localbusAddress === 6 && kanal?.fg === 6 && (kanal?.de === 1 || kanal?.de === 2|| kanal?.de === 3 ||kanal?.de === 4||kanal?.de === 7)"
                            [value]=6>STM
                            Eingang</mat-option>
                        <mat-option [value]=8>Verbindungsfehler</mat-option>

                    </mat-select>
                </mat-form-field>

                <mat-form-field
                    *ngIf="param.errorType !== 1 && param.errorType !== 6 && param.errorType !== 7 && param.errorType !==8">
                    <mat-label>Schwellenwert</mat-label>
                    <input matInput placeholder="Schwellenwert" type="number" [(ngModel)]="param.tresholdValue">
                </mat-form-field>

                <mat-slide-toggle
                    *ngIf="kanal?.localbusAddress === 6 && kanal?.fg === 6 && (kanal?.de === 1 || kanal?.de === 2 || kanal?.de === 3 || kanal?.de === 4) && param.errorType ===6"
                    [(ngModel)]="param.tresholdValue" color="primary"
                    (ngModelChange)="onTresholdValueToggleChanged($event, param)">
                    Reaktion auf: {{ param.tresholdValue ? 'aktiv' : 'inaktiv' }}
                </mat-slide-toggle>

                <mat-form-field>
                    <mat-label>Verzögerung (Sek.)</mat-label>
                    <input matInput placeholder="Verzögerung" type="number" [(ngModel)]="param.delay">
                </mat-form-field>
                <button [disabled]="param.errorType === 0 || param.errorType === undefined" mat-icon-button
                    (click)="createErrorTreshold()">
                    <img src="assets/icons/save_material.svg" height="24"/>
                </button>
            </div>

        </div>

        <div *ngIf="existingErrorThresholdParameters.length > 0"
            style="border-top: 2px solid black; margin-top: 8px; padding-top: 4px;">
            Bearbeitung von Schwellenwerten
            <div *ngFor="let param of existingErrorThresholdParameters">
                <mat-form-field>
                    <mat-label>Error Level</mat-label>
                    <mat-select [(ngModel)]="param.errorLevel" style="color: black"
                        (ngModelChange)="param.changed = true"
                        [ngClass]="isDuplicateErrorLevelAndTypeOfExisting(param) ? 'isDuplicate' : ''">
                        <mat-option [value]="0">Warnung</mat-option>
                        <mat-option [value]="1">Fehler</mat-option>
                        <mat-option [value]="2">Kritischer Fehler</mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field>
                    <mat-label>Error Type</mat-label>
                    <mat-select [(ngModel)]="param.errorType " (ngModelChange)="param.changed = true"
                        [ngClass]="isDuplicateErrorLevelAndTypeOfExisting(param) ? 'isDuplicate' : ''">
                        <mat-option [value]=1>Kanalfehler</mat-option>
                        <mat-option *ngIf="kanal?.localbusAddress === 1 || kanal?.localbusAddress === 2"
                            [value]=2>Pixelfehler</mat-option>
                        <mat-option *ngIf="kanal?.localbusAddress === 10" [value]=3>Spannungsfehler</mat-option>
                        <mat-option *ngIf="kanal?.localbusAddress === 12" [value]=4>Brennstoffwarnung</mat-option>
                        <mat-option *ngIf="kanal?.localbusAddress === 12" [value]=5>Systemstatus
                            Brennstoffzelle</mat-option>
                        <mat-option
                            *ngIf="kanal?.localbusAddress === 6 && (kanal?.de === 1 || kanal?.de === 2|| kanal?.de === 3 ||kanal?.de === 4||kanal?.de === 7)"
                            [value]=6>STM Eingang</mat-option>

                    </mat-select>
                </mat-form-field>

                <mat-form-field
                    *ngIf="param.errorType !== 1 && param.errorType !== 6 && param.errorType !== 7 && param.errorType !==8">
                    <mat-label>Schwellenwert</mat-label>
                    <input matInput placeholder="Schwellenwert" type="number" [(ngModel)]="param.tresholdValue"
                        (ngModelChange)="param.changed = true">
                </mat-form-field>


                <mat-slide-toggle
                    *ngIf="kanal?.localbusAddress === 6 && kanal?.fg === 6 && (kanal?.de === 1 || kanal?.de === 2 || kanal?.de === 3 || kanal?.de === 4) && param.errorType ===6"
                    [(ngModel)]="param.tresholdValue " color="primary"
                    (ngModelChange)="onTresholdValueToggleChanged($event, param)">
                    Reaktion auf: {{ param.tresholdValue ? 'aktiv' : 'inaktiv' }}
                </mat-slide-toggle>


                <mat-form-field>
                    <mat-label>Verzögerung</mat-label>
                    <input matInput placeholder="Verzögerung" type="number" [(ngModel)]="param.delay"
                        (ngModelChange)="param.changed = true">
                </mat-form-field>

                <button mat-icon-button (click)="editTresholdParameter(param)" [disabled]="!param.changed">
                    <img src="assets/icons/save_material.svg" height="24"/>
                </button>
                <button mat-icon-button (click)="deleteTresholdParameter(param)">
                    <img src="assets/icons/delete_material.svg" height="24"/>
                </button> 

            </div>
        </div>
    </div>

</mat-dialog-content>

<div mat-dialog-actions class="d-flex justify-content-end me-5">
    <button (click)="onCloseDialogClicked()" class="btn rounded-0 btn-outline-danger ms-sm-5 btn-sm mt-4 ">
        Schließen
    </button>
</div>